import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface DatenschutzState extends BasePageState {}
interface DatenschutzModel {}

export default class DatenschutzPage extends Basepage<
  DatenschutzState,
  DatenschutzModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="datenschutz">
        Datenschutzerklärung
        <br />
        <br />
        Soweit nachstehend keine anderen Angaben gemacht werden, ist die
        Bereitstellung Ihrer personenbezogenen Daten weder gesetzlich oder
        vertraglich vorgeschrieben, noch für einen Vertragsabschluss
        erforderlich. Sie sind zur Bereitstellung der Daten nicht verpflichtet.
        Eine Nichtbereitstellung hat keine Folgen. Dies gilt nur soweit bei den
        nachfolgenden Verarbeitungsvorgängen keine anderweitige Angabe gemacht
        wird.
        <br />
        "Personenbezogene Daten" sind alle Informationen, die sich auf eine
        identifizierte oder identifizierbare natürliche Person beziehen.
        <br />
        <br />
        <br />
        Server-Logfiles <br />
        Sie können unsere Webseiten besuchen, ohne Angaben zu Ihrer Person zu
        machen. <br />
        Bei jedem Zugriff auf unsere Website werden an uns oder unseren
        Webhoster / IT-Dienstleister Nutzungsdaten durch Ihren Internet Browser
        übermittelt und in Protokolldaten (sog. Server-Logfiles) gespeichert. Zu
        diesen gespeicherten Daten gehören z.B. der Name der aufgerufenen Seite,
        Datum und Uhrzeit des Abrufs, die IP-Adresse, die übertragene Datenmenge
        und der anfragende Provider. Die Verarbeitung erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse an der Gewährleistung eines störungsfreien Betriebs unserer
        Website sowie zur Verbesserung unseres Angebotes. <br />
        Kontakt
        <br />
        <br />
        Verantwortlicher
        <br />
        Kontaktieren Sie uns auf Wunsch. Verantwortlicher für die
        Datenverarbeitung ist: Helge Blischke / Moluna GmbH, Engberdingdamm 27,
        48268 Greven Deutschland, 02571/8072880, service@buchbutler.de
        <br />
        <br />
        <br />
        <br />
        <br />
        Initiativ-Kontaktaufnahme des Kunden per E-Mail
        <br />
        Wenn Sie per E-Mail initiativ mit uns in Geschäftskontakt treten,
        erheben wir Ihre personenbezogenen Daten (Name, E-Mail-Adresse,
        Nachrichtentext) nur in dem von Ihnen zur Verfügung gestellten Umfang.
        Die Datenverarbeitung dient der Bearbeitung und Beantwortung Ihrer
        Kontaktanfrage.
        <br />
        Wenn die Kontaktaufnahme der Durchführung vorvertraglichen Maßnahmen
        (bspw. Beratung bei Kaufinteresse, Angebotserstellung) dient oder einen
        bereits zwischen Ihnen und uns geschlossenen Vertrag betrifft, erfolgt
        diese Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO.
        <br />
        Erfolgt die Kontaktaufnahme aus anderen Gründen erfolgt diese
        Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO aus
        unserem überwiegenden berechtigten Interesse an der Bearbeitung und
        Beantwortung Ihrer Anfrage. In diesem Fall haben Sie das Recht, aus
        Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit
        dieser auf Art. 6 Abs. 1 lit. f DSGVO beruhenden Verarbeitungen Sie
        betreffender personenbezogener Daten zu widersprechen.
        <br />
        Ihre E-Mail-Adresse nutzen wir nur zur Bearbeitung Ihrer Anfrage. Ihre
        Daten werden anschließend unter Beachtung gesetzlicher
        Aufbewahrungsfristen gelöscht, sofern Sie der weitergehenden
        Verarbeitung und Nutzung nicht zugestimmt haben.
        <br />
        Erhebung und Verarbeitung bei Nutzung des Kontaktformulars <br />
        Bei der Nutzung des Kontaktformulars erheben wir Ihre personenbezogenen
        Daten (Name, E-Mail-Adresse, Nachrichtentext) nur in dem von Ihnen zur
        Verfügung gestellten Umfang. Die Datenverarbeitung dient dem Zweck der
        Kontaktaufnahme.
        <br />
        Wenn die Kontaktaufnahme der Durchführung vorvertraglichen Maßnahmen
        (bspw. Beratung bei Kaufinteresse, Angebotserstellung) dient oder einen
        bereits zwischen Ihnen und uns geschlossenen Vertrag betrifft, erfolgt
        diese Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO.
        Erfolgt die Kontaktaufnahme aus anderen Gründen erfolgt diese
        Datenverarbeitung auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO aus
        unserem überwiegenden berechtigten Interesse an der Bearbeitung und
        Beantwortung Ihrer Anfrage. In diesem Fall haben Sie das Recht, aus
        Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit
        dieser auf Art. 6 Abs. 1 lit. f DSGVO beruhenden Verarbeitungen Sie
        betreffender personenbezogener Daten zu widersprechen. Ihre
        E-Mail-Adresse nutzen wir nur zur Bearbeitung Ihrer Anfrage. Ihre Daten
        werden anschließend unter Beachtung gesetzlicher Aufbewahrungsfristen
        gelöscht, sofern Sie der weitergehenden Verarbeitung und Nutzung nicht
        zugestimmt haben.
        <br />
        <br />
        <br />
        Kundenkonto Bestellungen <br />
        <br />
        Kundenkonto
        <br />
        Bei der Eröffnung eines Kundenkontos erheben wir Ihre personenbezogenen
        Daten in dem dort angegebenen Umfang. Die Datenverarbeitung dient dem
        Zweck, Ihr Einkaufserlebnis zu verbessern und die Bestellabwicklung zu
        vereinfachen. Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1
        lit. a DSGVO mit Ihrer Einwilligung. Sie können Ihre Einwilligung
        jederzeit durch Mitteilung an uns widerrufen, ohne dass die
        Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
        Verarbeitung berührt wird. Ihr Kundenkonto wird anschließend gelöscht.
        <br />
        <br />
        <br />
        Erhebung, Verarbeitung und Weitergabe personenbezogener Daten bei
        Bestellungen <br />
        Bei der Bestellung erheben und verarbeiten wir Ihre personenbezogenen
        Daten nur, soweit dies zur Erfüllung und Abwicklung Ihrer Bestellung
        sowie zur Bearbeitung Ihrer Anfragen erforderlich ist. Die
        Bereitstellung der Daten ist für den Vertragsschluss erforderlich. Eine
        Nichtbereitstellung hat zur Folge, dass kein Vertrag geschlossen werden
        kann. Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1 lit. b
        DSGVO und ist für die Erfüllung eines Vertrags mit Ihnen erforderlich.{' '}
        <br />
        Eine Weitergabe Ihrer Daten erfolgt dabei beispielsweise an die von
        Ihnen gewählten Versandunternehmen und Dropshipping Anbieter,
        Zahlungsdienstleister, Diensteanbieter für die Bestellabwicklung und
        IT-Dienstleister. In allen Fällen beachten wir strikt die gesetzlichen
        Vorgaben. Der Umfang der Datenübermittlung beschränkt sich auf ein
        Mindestmaß.
        <br />
        <br />
        Werbung <br />
        <br />
        Verwendung Ihrer personenbezogenen Daten für die Zusendung postalischer
        Werbung
        <br />
        Wir nutzen Ihre personenbezogenen Daten (Name, Anschrift), die wir im
        Rahmen des Verkaufs einer Ware oder Dienstleistung erhalten haben, um
        Ihnen postalische Werbung zuzusenden, sofern Sie dieser Verwendung nicht
        widersprochen haben. Die Bereitstellung dieser Daten ist für den
        Vertragsschluss erforderlich. Eine Nichtbereitstellung hat zur Folge,
        dass kein Vertrag geschlossen werden kann.
        <br />
        Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f DSGVO
        aus unserem überwiegenden berechtigten Interesse an Direktwerbung. Sie
        können dieser Verwendung Ihrer Adressdaten jederzeit durch Mitteilung an
        uns widersprechen. Die Kontaktdaten für die Ausübung des Widerspruchs
        finden Sie im Impressum.
        <br />
        <br />
        Verwendung der E-Mail-Adresse für die Zusendung von Direktwerbung <br />
        Wir nutzen Ihre E-Mail-Adresse, die wir im Rahmen des Verkaufes einer
        Ware oder Dienstleistung erhalten haben, für die elektronische
        Übersendung von Werbung für eigene Waren oder Dienstleistungen, die
        denen ähnlich sind, die Sie bereits bei uns erworben haben, soweit Sie
        dieser Verwendung nicht widersprochen haben. Die Bereitstellung der
        E-Mail-Adresse ist für den Vertragsschluss erforderlich. Eine
        Nichtbereitstellung hat zur Folge, dass kein Vertrag geschlossen werden
        kann. Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f
        DSGVO aus unserem überwiegenden berechtigten Interesse an Direktwerbung.
        Sie können dieser Verwendung Ihrer E-Mail-Adresse jederzeit durch
        Mitteilung an uns widersprechen. Die Kontaktdaten für die Ausübung des
        Widerspruchs finden Sie im Impressum. Sie können auch den dafür
        vorgesehenen Link in der Werbe-E-Mail nutzen. Hierfür entstehen keine
        anderen als die Übermittlungskosten nach den Basistarifen.
        <br />
        <br />
        <br />
        Versanddienstleister <br />
        <br />
        Weitergabe der E-Mail-Adresse an Versandunternehmen zur Information über
        den Versandstatus
        <br />
        Wir geben Ihre E-Mail-Adresse im Rahmen der Vertragsabwicklung an das
        Transportunternehmen weiter, sofern Sie dem ausdrücklich im
        Bestellvorgang zugestimmt haben. Die Weitergabe dient dem Zweck, Sie per
        E-Mail über den Versandstatus zu informieren. Die Verarbeitung erfolgt
        auf Grundlage des Art. 6 Abs. 1 lit. a DSGVO mit Ihrer Einwilligung. Sie
        können die Einwilligung jederzeit durch Mitteilung an uns oder das
        Transportunternehmen widerrufen, ohne dass die Rechtmäßigkeit der
        aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung
        berührt wird.
        <br />
        <br />
        <br />
        Zahlungsdienstleister Bonitätsauskunft <br />
        <br />
        Verwendung von PayPal
        <br />
        Alle PayPal-Transaktionen unterliegen der PayPal-Datenschutzerklärung.
        Diese finden Sie unter
        https://www.paypal.com/de/webapps/mpp/ua/privacy-full
        (https://www.paypal.com/de/webapps/mpp/ua/privacy-full)
        <br />
        <br />
        Verwendung von PayPal Express
        <br />
        Wir verwenden auf unserer Website den Zahlungsdienst PayPal Express der
        PayPal (Europe) S.à.r.l. et Cie, S.C.A. (22-24 Boulevard Royal L-2449,
        Luxemburg; "PayPal"). Die Datenverarbeitung dient dem Zweck, Ihnen die
        Zahlung über den Zahlungsdienst PayPal Express anbieten zu können. Zur
        Einbindung dieses Zahlungsdienstes ist es erforderlich, dass PayPal beim
        Aufruf der Website Daten (z.B. IP-Adresse, Gerätetyp, Betriebssystem,
        Browsertyp, Standort Ihres Geräts) sammelt, speichert und analysiert.
        Hierzu können auch Cookies eingesetzt werden. Die Cookies ermöglichen
        die Wiedererkennung Ihres Browsers.
        <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse an einem kundenorientierten Angebot von verschiedenen
        Zahlarten. Sie haben das Recht aus Gründen, die sich aus Ihrer
        besonderen Situation ergeben, jederzeit dieser Verarbeitungen Sie
        betreffender personenbezogener Daten zu widersprechen.
        <br />
        Mit Auswahl und Nutzung von PayPal Express werden die zur
        Zahlungsabwicklung erforderlichen Daten an PayPal übermittelt, um den
        Vertrag mit Ihnen mit der gewählten Zahlart erfüllen zu können. Diese
        Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO.
        Nähere Informationen zur Datenverarbeitung bei Verwendung des
        Zahlungsdienstes PayPal Express finden Sie in der dazugehörigen
        Datenschutzerklärung unter
        www.paypal.com/de/webapps/mpp/ua/privacy-full?locale.x=de_DE#Updated_PS
        (http://www.paypal.com/de/webapps/mpp/ua/privacy-full?locale.x=de_DE#Updated_PS).
        <br />
        <br />
        Verwendung der personenbezogenen Daten bei Auswahl von Klarna
        Zahlungsoptionen
        <br />
        Um Ihnen die Zahlungsoptionen von Klarna anbieten zu können, werden wir
        personenbezogene Daten, wie beispielsweise Kontaktdaten und
        Bestelldaten, an Klarna übermitteln. So kann Klarna beurteilen, ob Sie
        die über Klarna angebotenen Zahlungsoptionen in Anspruch nehmen können
        und die Zahlungsoptionen an Ihre Bedürfnisse anpassen. Allgemeine
        Informationen zu Klarna erhalten Sie unter: https://www.klarna.com/de/
        (https://www.klarna.com/de/). Ihre Personenangaben werden von Klarna in
        Übereinstimmung mit den geltenden Datenschutzbestimmungen und
        entsprechend den Angaben in Klarnas Datenschutzbestimmungen unter
        https://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_de/privacy
        (https://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_de/privacy)
        behandelt.
        <br />
        <br />
        <br />
        <br />
        Cookies <br />
        <br />
        Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die
        im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem eines
        Nutzers gespeichert werden. Ruft ein Nutzer eine Website auf, so kann
        ein Cookie auf dem Betriebssystem des Nutzers gespeichert werden. Dieser
        Cookie enthält eine charakteristische Zeichenfolge, die eine eindeutige
        Identifizierung des Browsers beim erneuten Aufrufen der Website
        ermöglicht. <br />
        <br />
        Cookies werden auf Ihrem Rechner gespeichert. Daher haben Sie die volle
        Kontrolle über die Verwendung von Cookies. Durch die Auswahl
        entsprechender technischer Einstellungen in Ihrem Internetbrowser können
        Sie vor dem Setzen von Cookies benachrichtigt werden und über die
        Annahme einzeln entscheiden sowie die Speicherung der Cookies und
        Übermittlung der enthaltenen Daten verhindern. Bereits gespeicherte
        Cookies können jederzeit gelöscht werden. Wir weisen Sie jedoch darauf
        hin, dass Sie dann gegebenenfalls nicht sämtliche Funktionen dieser
        Website vollumfänglich werden nutzen können. <br />
        <br />
        Unter den nachstehenden Links können Sie sich informieren, wie Sie die
        Cookies bei den wichtigsten Browsern verwalten (u.a. auch deaktivieren)
        können: <br />
        Chrome: https://support.google.com/accounts/answer/61416?hl=de
        (https://support.google.com/accounts/answer/61416?hl=de)
        <br />
        Internet Explorer:
        https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies
        (https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies){' '}
        <br />
        Mozilla Firefox:
        https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen
        (https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen) <br />
        Safari:
        https://support.apple.com/de-de/guide/safari/manage-cookies-and-website-data-sfri11471/mac
        (https://support.apple.com/de-de/guide/safari/manage-cookies-and-website-data-sfri11471/mac){' '}
        <br />
        <br />
        <br />
        Technisch notwendige Cookies <br />
        Soweit nachstehend in der Datenschutzerklärung keine anderen Angaben
        gemacht werden setzen wir nur diese technisch notwendigen Cookies zu dem
        Zweck ein, unser Angebot nutzerfreundlicher, effektiver und sicherer zu
        machen. Des Weiteren ermöglichen Cookies unseren Systemen, Ihren Browser
        auch nach einem Seitenwechsel zu erkennen und Ihnen Services anzubieten.
        Einige Funktionen unserer Internetseite können ohne den Einsatz von
        Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der
        Browser auch nach einem Seitenwechsel wiedererkannt wird. <br />
        <br />
        Die Nutzung von Cookies oder vergleichbarer Technologien erfolgt auf
        Grundlage des § 25 Abs. 2 TTDSG. Die Verarbeitung Ihrer
        personenbezogenen Daten erfolgt auf Grundlage des Art. 6 Abs. 1 lit. f
        DSGVO aus unserem überwiegenden berechtigten Interesse an der
        Gewährleistung der optimalen Funktionalität der Website sowie einer
        nutzerfreundlichen und effektiven Gestaltung unseres Angebots. <br />
        Sie haben das Recht aus Gründen, die sich aus Ihrer besonderen Situation
        ergeben, jederzeit dieser Verarbeitungen Sie betreffender
        personenbezogener Daten zu widersprechen.
        <br />
        Verwendung von Consentmanager
        <br />
        Wir verwenden auf unserer Website das Consent-Management-Tool
        Consentmanager der Consentmanager AB (Håltegelvägen 1b, 72348 Västerås,
        Schweden; "Consentmanager").
        <br />
        Das Tool ermöglicht es Ihnen, Einwilligungen in Datenverarbeitungen über
        die Website, insbesondere das Setzen von Cookies, zu erteilen sowie von
        Ihrem Widerrufsrecht für bereits erteilte Einwilligungen Gebrauch zu
        machen.
        <br />
        Die Datenverarbeitung dient dem Zweck, erforderliche Einwilligungen in
        Datenverarbeitungen einzuholen sowie zu dokumentieren und damit
        gesetzliche Verpflichtungen einzuhalten.
        <br />
        Hierzu können Cookies eingesetzt werden. Dabei können u. a. folgende
        Informationen erhoben und an Consentmanager übermittelt werden: Datum
        und Uhrzeit des Seitenaufrufs, Informationen zu dem von Ihnen
        verwendeten Browser und das von Ihnen genutzte Gerät, anonymisierte
        IP-Adresse, Opt-in- und Opt-out-Daten. Eine Weitergabe dieser Daten an
        sonstige Dritte erfolgt nicht.
        <br />
        Die Datenverarbeitung erfolgt zur Erfüllung einer rechtlichen
        Verpflichtung auf Grundlage des Art. 6 Abs. 1 lit. c DSGVO.
        <br />
        Nähere Informationen zum Datenschutz bei Consentmanager finden Sie
        unter: https://www.consentmanager.net/privacy.php
        (https://www.consentmanager.net/privacy.php)
        <br />
        <br />
        Analyse Werbetracking <br />
        <br />
        Verwendung von Google Analytics
        <br />
        Wir verwenden auf unserer Website den Webanalysedienst Google Analytics
        der Google Google Ireland Limited (Gordon House, Barrow Street, Dublin
        4, Irland; "Google").
        <br />
        Die Datenverarbeitung dient dem Zweck der Analyse dieser Website und
        ihrer Besucher sowie für Marketing- und Werbezwecke. Dazu wird Google im
        Auftrag des Betreibers dieser Website die gewonnenen Informationen
        benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die
        Websiteaktivitäten zusammenzustellen und um weitere, mit der
        Websitenutzung und der Internetnutzung verbundene Dienstleistungen
        gegenüber dem Websitebetreiber zu erbringen. Dabei können u.a. folgende
        Informationen erhoben werden: IP-Adresse, Datum und Uhrzeit des
        Seitenaufrufs, Klickpfad, Informationen über den von Ihnen verwendeten
        Browser und das von Ihnen verwendete Device (Gerät), besuchte Seiten,
        Referrer-URL (Webseite, über die Sie unsere Webseite aufgerufen haben),
        Standortdaten, Kaufaktivitäten. Die im Rahmen von Google Analytics von
        Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von
        Google zusammengeführt.
        <br />
        Google Analytics verwendet Technologien wie Cookies, Webspeicher im
        Browser und Zählpixel, die eine Analyse der Benutzung der Website durch
        Sie ermöglichen. Die dadurch erzeugten Informationen über Ihre Benutzung
        dieser Website werden in der Regel an einen Server von Google in den USA
        übertragen und dort gespeichert. Für die USA ist kein
        Angemessenheitsbeschluss der EU-Kommission vorhanden. Die
        Datenübermittlung erfolgt u.a auf Grundlage von Standardvertragsklauseln
        als geeignete Garantien für den Schutz der personenbezogenen Daten,
        einsehbar unter: https://policies.google.com/privacy/frameworks
        (https://policies.google.com/privacy/frameworks) und
        https://business.safety.google/adsprocessorterms/.
        (https://business.safety.google/adsprocessorterms/) Sowohl Google als
        auch staatliche US-Behörden haben Zugriff auf Ihre Daten. Ihre Daten
        können von Google mit anderen Daten, wie beispielsweise Ihrem
        Suchverlauf, Ihren persönlichen Accounts, Ihren Nutzungsdaten anderer
        Geräte und allen anderen Daten, die Google zu Ihnen vorliegen hat,
        verknüpft werden.
        <br />
        Auf dieser Website ist die IP-Anonymisierung aktiviert. Dadurch wird
        Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der
        Europäischen Union oder in anderen Vertragsstaaten des Abkommens über
        den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen
        wird die volle IP-Adresse an einen Server von Google in den USA
        übertragen und dort gekürzt.
        <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse an der bedarfsgerechten und zielgerichteten Gestaltung der
        Website. Sie haben das Recht aus Gründen, die sich aus Ihrer besonderen
        Situation ergeben, jederzeit dieser Verarbeitungen Sie betreffender
        personenbezogener Daten zu widersprechen.
        <br />
        Sie können die Erfassung der durch Google Analytics erzeugten und auf
        Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an
        Google sowie die Verarbeitung dieser Daten durch Google verhindern,
        indem Sie das unter dem folgenden Link verfügbare Browser-Plug-in
        herunterladen und installieren:
        https://tools.google.com/dlpage/gaoptout?hl=de
        (https://tools.google.com/dlpage/gaoptout?hl=de)
        <br />
        Um die Datenerfassung und -speicherung durch Google Analytics
        geräteübergreifend zu verhindern, können Sie einen Opt-Out-Cookie
        setzen. Opt-Out-Cookies verhindern die zukünftige Erfassung Ihrer Daten
        beim Besuch dieser Website. Sie müssen das Opt-Out auf allen genutzten
        Systemen und Geräten durchführen, damit dies umfassend wirkt. Wenn Sie
        das Opt-out-Cookie löschen, werden wieder Anfragen an Google
        übermittelt. Wenn Sie hier klicken, wird das Opt-Out-Cookie gesetzt:
        Google Analytics deaktivieren (javascript:gaOptout()).
        <br />
        Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie
        unter https://www.google.com/analytics/terms/de.html
        (https://www.google.com/analytics/terms/de.html) bzw. unter
        https://www.google.de/intl/de/policies/
        (https://www.google.de/intl/de/policies/) sowie unter
        https://policies.google.com/technologies/cookies?hl=de
        (https://policies.google.com/technologies/cookies?hl=de).
        <br />
        <br />
        Verwendung des Facebook Pixel
        <br />
        Wir verwenden auf unserer Website die Remarketing-Funktion "Custom
        Audiences" der Meta Platforms Ireland Limited (4 Grand Canal Square,
        Grand Canal Harbour, Dublin 2, Irland "Facebook").
        <br />
        Meta Platforms Ireland und wir sind gemeinsam Verantwortliche für die
        bei Einbindung des Dienstes stattfindende Erhebung Ihrer Daten und
        Übermittlung dieser Daten an Facebook. Grundlage dafür ist eine
        Vereinbarung zwischen uns und Meta Platforms Ireland über die gemeinsame
        Verarbeitung personenbezogener Daten, in der die jeweiligen
        Verantwortlichkeiten festgelegt werden. Die Vereinbarung ist unter
        https://www.facebook.com/legal/controller_addendum
        (https://www.facebook.com/legal/controller_addendum) aufrufbar. Danach
        sind wir insbesondere verantwortlich für die Erfüllung der
        Informationspflichten gemäß der Art. 13, 14 DSGVO, für die Einhaltung
        der Sicherheitsvorgaben des Art. 32 DSGVO im Hinblick auf die korrekte
        technische Implementierung und Konfiguration des Dienstes sowie zur
        Einhaltung der Verpflichtungen nach den Art. 33, 34 DSGVO, soweit eine
        Verletzung des Schutzes personenbezogener Daten unsere Verpflichtungen
        gemäß der Vereinbarung über die gemeinsame Verarbeitung betrifft. Meta
        Platforms Ireland obliegt die Verantwortung, die Betroffenenrechte gemäß
        den Art. 15 - 20 DSGVO zu ermöglichen, die Sicherheitsvorgaben des Art.
        32 DSGVO im Hinblick auf die Sicherheit des Dienstes einzuhalten und die
        Verpflichtungen nach den Art. 33, 34 DSGVO, soweit eine Verletzung des
        Schutzes personenbezogener Daten die Verpflichtungen von Meta Platforms
        Ireland gemäß der Vereinbarung über die gemeinsame Verarbeitung
        betrifft.
        <br />
        Die Anwendung dient dem Zweck die Besucher der Website zielgerichtet mit
        interessenbezogener Werbung im sozialen Netzwerk Facebook anzusprechen.
        Dazu wurde auf der Website das Remarketing-Tag von Facebook
        implementiert. Über dieses Tag wird beim Besuch der Website eine direkte
        Verbindung zu den Facebook-Servern hergestellt. Hierdurch wird an den
        Facebook-Server übermittelt, welche unserer Seiten Sie besucht haben.
        Facebook ordnet diese Information Ihrem persönlichen
        Facebook-Benutzerkonto zu. Wenn Sie das soziale Netzwerk Facebook
        besuchen, werden Ihnen dann personalisierte, interessenbezogene
        Facebook-Ads angezeigt.
        <br />
        Ihre Daten werden gegebenenfalls in die USA übermittelt. Für die USA ist
        kein Angemessenheitsbeschluss der EU-Kommission vorhanden. Die
        Datenübermittlung erfolgt u.a auf Grundlage von Standardvertragsklauseln
        als geeignete Garantien für den Schutz der personenbezogenen Daten,
        einsehbar unter:
        https://www.facebook.com/legal/EU_data_transfer_addendum
        (https://www.facebook.com/legal/EU_data_transfer_addendum).
        <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse die Seitenbesucher zielgerichtet mit interessenbezogener
        Werbung anzusprechen. Sie haben das Recht aus Gründen, die sich aus
        Ihrer besonderen Situation ergeben, jederzeit dieser Verarbeitungen Sie
        betreffender personenbezogener Daten zu widersprechen. Sie können die
        Remarketing-Funktion "Custom Audiences" hier () deaktivieren.
        <br />
        Nähere Informationen zur Erhebung und Nutzung der Daten durch Facebook,
        über Ihre diesbezüglichen Rechte und Möglichkeiten zum Schutz Ihrer
        Privatsphäre finden Sie in den Datenschutzhinweisen von Facebook unter
        https://www.facebook.com/about/privacy/
        (https://www.facebook.com/about/privacy/). <br />
        <br />
        <br />
        Verwendung von Google Ads Conversion-Tracking
        <br />
        Wir verwenden auf unserer Website das Online-Werbeprogramm "Google Ads"
        und in diesem Rahmen Conversion-Tracking (Besuchsaktionsauswertung). Das
        Google Conversion Tracking ist ein Analysedienst der Google Ireland
        Limited (Gordon House, Barrow Street, Dublin 4, Irland).
        <br />
        Wenn Sie auf eine von Google geschaltete Anzeige klicken, wird ein
        Cookie für das Conversion-Tracking auf Ihrem Rechner abgelegt. Diese
        Cookies haben eine begrenzte Gültigkeit, enthalten keine
        personenbezogenen Daten und dienen somit nicht der persönlichen
        Identifizierung. Wenn Sie bestimmte Seiten unserer Website besuchen und
        das Cookie noch nicht abgelaufen ist, können Google und wir erkennen,
        dass Sie auf die Anzeige geklickt haben und zu dieser Seite
        weitergeleitet wurden. Jeder Google Ads-Kunde erhält ein anderes Cookie.
        Somit besteht keine Möglichkeit, dass Cookies über die Websites von
        Ads-Kunden nachverfolgt werden können.
        <br />
        Die Informationen, die mit Hilfe des Conversion-Cookie eingeholt werden,
        dienen dem Zweck Conversion-Statistiken zu erstellen. Hierbei erfahren
        wir die Gesamtanzahl der Nutzer, die auf eine unserer Anzeigen geklickt
        haben und zu einer mit einem Conversion-Tracking-Tag versehenen Seite
        weitergeleitet wurden. Wir erhalten jedoch keine Informationen, mit
        denen sich Nutzer persönlich identifizieren lassen.
        <br />
        Ihre Daten werden gegebenenfalls an die Server der Google LLC in die USA
        übermittelt. Für die USA ist kein Angemessenheitsbeschluss der
        EU-Kommission vorhanden. Die Datenübermittlung erfolgt u.a auf Grundlage
        von Standardvertragsklauseln als geeignete Garantien für den Schutz der
        personenbezogenen Daten, einsehbar unter:
        https://policies.google.com/privacy/frameworks
        (https://policies.google.com/privacy/frameworks) und
        https://business.safety.google/adscontrollerterms/
        (https://business.safety.google/adscontrollerterms/). <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse die Seitenbesucher zielgerichtet mit interessenbezogener
        Werbung anzusprechen. Sie haben das Recht aus Gründen, die sich aus
        Ihrer besonderen Situation ergeben, jederzeit dieser Verarbeitungen Sie
        betreffender personenbezogener Daten zu widersprechen.
        <br />
        Sie können in den Einstellungen für Werbung bei Google für Sie
        personalisierte Werbung deaktivieren. Eine Anleitung dazu finden Sie
        unter https://support.google.com/ads/answer/2662922?hl=de
        (https://support.google.com/ads/answer/2662922?hl=de) <br />
        Alternativ können Sie die Verwendung von Cookies durch Drittanbieter
        verhindern, indem Sie die Deaktivierungsseite der
        Netzwerkwerbeinitiative (Network Advertising Initiative) unter
        https://www.networkadvertising.org/choices/
        (https://www.networkadvertising.org/choices/) aufrufen und die dort
        genannten weiterführenden Information zum Opt-Out umsetzen. Sie werden
        sodann nicht in die Conversion-Tracking Statistiken aufgenommen.
        <br />
        Nähere Informationen sowie die Datenschutzerklärung von Google finden
        Sie unter: https://www.google.de/policies/privacy/
        (https://www.google.de/policies/privacy/)
        <br />
        <br />
        Verwendung von Google AdSense <br />
        Wir verwenden auf unserer Website die AdSense-Funktion der Google
        Ireland Limited (Gordon House, Barrow Street, Dublin 4, Irland) Die
        Datenverarbeitung dient dem Zweck, Werbeflächen auf der Website zu
        vermieten und auf diesen die Besucher der Website zielgerichtet mit
        interessenbezogener Werbung anzusprechen. Mittels dieser Funktion werden
        den Besuchern der Website des Anbieters personalisierte,
        interessenbezogene Werbung-Anzeigen aus dem Google Display-Netzwerk
        geschaltet. Dabei verwendet Google Cookies, die eine Analyse der
        Benutzung der Website durch Sie ermöglichen. Die durch den Cookie
        erzeugten Informationen über Ihre Benutzung dieser Website werden in der
        Regel an einen Server von Google in den USA übertragen und dort
        gespeichert. Für die USA ist kein Angemessenheitsbeschluss der
        EU-Kommission vorhanden. Die Datenübermittlung erfolgt u.a auf Grundlage
        von Standardvertragsklauseln als geeignete Garantien für den Schutz der
        personenbezogenen Daten, einsehbar unter:
        https://policies.google.com/privacy/frameworks
        (https://policies.google.com/privacy/frameworks) und
        https://business.safety.google/adscontrollerterms/
        (https://business.safety.google/adscontrollerterms/). Google wird diese
        Informationen gegebenenfalls an Dritte übertragen, sofern dies
        gesetzlich vorgeschrieben ist oder soweit Dritte diese Daten im Auftrag
        von Google verarbeiten. Google wird in keinem Fall Ihre IP-Adresse mit
        anderen Daten von Google in Verbindung bringen. <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse die Seitenbesucher zielgerichtet mit interessenbezogener
        Werbung anzusprechen. Sie haben das Recht aus Gründen, die sich aus
        Ihrer besonderen Situation ergeben, jederzeit dieser Verarbeitungen Sie
        betreffender personenbezogener Daten zu widersprechen. Sie können die
        Verwendung von Cookies durch Google dauerhaft deaktivieren, indem Sie
        dem nachfolgenden Link folgen und das dort bereitgestellte Plug-In
        herunterladen und installieren:
        https://support.google.com/ads/answer/7395996?hl=de
        (https://support.google.com/ads/answer/7395996?hl=de). Alternativ können
        Sie die Verwendung von Cookies durch Drittanbieter verhindern, indem sie
        die Deaktivierungsseite der Netzwerkwerbeinitiative (Network Advertising
        Initiative) unter https://www.networkadvertising.org/choices/
        (https://www.networkadvertising.org/choices/)aufrufen und die dort
        genannten weiterführenden Information zum Opt-Out umsetzen. Nähere
        Informationen sowie die Datenschutzerklärung von Google finden Sie
        unter: https://www.google.com/policies/technologies/ads/
        (https://www.google.com/policies/technologies/ads/) und
        https://www.google.de/policies/privacy/
        (https://www.google.de/policies/privacy/)
        <br />
        <br />
        Verwendung der Remarketing- oder "Ähnliche Zielgruppen"-Funktion der
        Google Inc.
        <br />
        Wir verwenden auf unserer Website die Remarketing- oder "Ähnliche
        Zielgruppen"- Funktion der Google Ireland Limited (Gordon House, Barrow
        Street, Dublin 4, Irland).
        <br />
        Die Anwendung dient dem Zweck der Analyse des Besucherverhaltens und der
        Besucherinteressen. Zur Durchführung der Analyse der Websiten-Nutzung,
        welche die Grundlage für die Erstellung der interessenbezogenen
        Werbeanzeigen bildet, setzt Google Cookies ein. Über die Cookies werden
        die Besuche der Website sowie anonymisierte Daten über die Nutzung der
        Website erfasst. Es erfolgt keine Speicherung von personenbezogenen
        Daten der Besucher der Website. Besuchen Sie nachfolgend eine andere
        Website im Google Display-Netzwerk werden Ihnen Werbeeinblendungen
        angezeigt, die mit hoher Wahrscheinlichkeit zuvor aufgerufene Produkt-
        und Informationsbereiche berücksichtigen.
        <br />
        Ihre Daten werden gegebenenfalls an Server der Google LLC in die USA
        übermittelt. Für die USA ist kein Angemessenheitsbeschluss der
        EU-Kommission vorhanden. Die Datenübermittlung erfolgt u.a auf Grundlage
        von Standardvertragsklauseln als geeignete Garantien für den Schutz der
        personenbezogenen Daten, einsehbar unter:
        https://policies.google.com/privacy/frameworks
        (https://policies.google.com/privacy/frameworks).
        <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse die Seitenbesucher zielgerichtet mit interessenbezogener
        Werbung anzusprechen. Sie haben das Recht aus Gründen, die sich aus
        Ihrer besonderen Situation ergeben, jederzeit dieser Verarbeitungen Sie
        betreffender personenbezogener Daten zu widersprechen.
        <br />
        Sie können die Verwendung von Cookies durch Google dauerhaft
        deaktivieren, indem Sie dem nachfolgenden Link folgen und das dort
        bereitgestellte Plug-In herunterladen und installieren:
        https://support.google.com/ads/answer/7395996?hl=de
        (https://support.google.com/ads/answer/7395996?hl=de)
        <br />
        Alternativ können Sie die Verwendung von Cookies durch Drittanbieter
        verhindern, indem sie die Deaktivierungsseite der
        Netzwerkwerbeinitiative (Network Advertising Initiative) unter
        https://www.networkadvertising.org/choices/
        (https://www.networkadvertising.org/choices/) aufrufen und die dort
        genannten weiterführenden Information zum Opt-Out umsetzen.
        <br />
        Nähere Informationen zu Google Remarketing sowie die dazugehörige
        Datenschutzerklärung finden Sie unter:
        https://www.google.com/privacy/ads/
        (https://www.google.com/privacy/ads/)
        <br />
        <br />
        Plug-ins und Sonstiges
        <br />
        <br />
        <br />
        Verwendung des Google Tag Managers
        <br />
        Wir verwenden auf unserer Website den Google Tag Manager der Google
        Ireland Limited (Gordon House, Barrow Street, Dublin 4, Irland;
        "Google"). <br />
        Mit dieser Anwendung werden JavaScript-Tags und HTML-Tags verwaltet, die
        zur Implementierung insbesondere von Tracking- und Analyse-Tools
        verwendet werden. Die Datenverarbeitung dient dem Zweck der
        bedarfsgerechten Gestaltung und der Optimierung unserer Website.
        <br />
        Der Google Tag Manager selbst speichert weder Cookies noch werden
        hierdurch personenbezogene Daten verarbeitet. Er ermöglicht jedoch die
        Auslösung weiterer Tags, die personenbezogene Daten erheben und
        verarbeiten können.
        <br />
        Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie
        hier (https://www.google.com/intl/de/tagmanager/use-policy.html).
        <br />
        <br />
        <br />
        Verwendung von Google reCAPTCHA <br />
        Wir verwenden auf unserer Website den Dienst reCAPTCHA der Google
        Ireland Limited (Gordon House, Barrow Street, Dublin 4, Irland;
        "Google"). Die Abfrage dient dem Zweck der Unterscheidung der Eingabe
        durch einen Menschen oder durch automatisierte, maschinelle
        Verarbeitung. Dazu wird Ihre Eingabe an Google übermittelt und dort
        weiterverwendet. Zusätzlich werden die IP-Adresse und gegebenenfalls
        weitere von Google für den Dienst reCAPTCHA benötigte Daten an Google
        übertragen. Diese Daten werden von Google innerhalb der Europäischen
        Union verarbeitet und gegebenenfalls auch an die Server der Google LLC
        in die USA übermittelt. Für die USA ist kein Angemessenheitsbeschluss
        der EU-Kommission vorhanden. Die Datenübermittlung erfolgt u.a auf
        Grundlage von Standardvertragsklauseln als geeignete Garantien für den
        Schutz der personenbezogenen Daten, einsehbar unter:
        https://policies.google.com/privacy/frameworks
        (https://policies.google.com/privacy/frameworks). <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse unsere Website vor automatisierter Ausspähung, Missbrauch und
        SPAM zu schützen. Sie haben das Recht aus Gründen, die sich aus Ihrer
        besonderen Situation ergeben, jederzeit dieser auf Art. 6 Abs. 1 lit. f
        DSGVO beruhenden Verarbeitungen Sie betreffender personenbezogener Daten
        zu widersprechen. <br />
        Nähere Informationen zu Google reCAPTCHA sowie die dazugehörige
        Datenschutzerklärung finden Sie unter:
        https://www.google.com/recaptcha/intro/android.html
        (https://www.google.com/recaptcha/intro/android.html) sowie
        https://www.google.com/privacy (https://www.google.com/privacy). <br />
        <br />
        <br />
        Verwendung von Google invisible reCAPTCHA
        <br />
        Wir verwenden auf unserer Website den Dienst invisible reCAPTCHA der
        Google Ireland Limited (Gordon House, Barrow Street, Dublin 4, Irland;
        "Google").
        <br />
        Dies dient dem Zweck der Unterscheidung der Eingabe durch einen Menschen
        oder durch automatisierte, maschinelle Verarbeitung. Im Hintergrund
        sammelt und analysiert Google Nutzungsdaten, die von Invisible reCaptcha
        dazu verwendet werden, um reguläre Benutzer von Bots zu unterscheiden.
        Dazu wird Ihre Eingabe an Google übermittelt und dort weiterverwendet.
        Zusätzlich werden die IP-Adresse und gegebenenfalls weitere von Google
        für den Dienst Invisible reCAPTCHA benötigte Daten an Google übertragen.
        <br />
        Diese Daten werden von Google innerhalb der Europäischen Union und
        gegebenenfalls auch in der USA verarbeitet. Für die USA ist kein
        Angemessenheitsbeschluss der EU-Kommission vorhanden. Die
        Datenübermittlung erfolgt u.a auf Grundlage von Standardvertragsklauseln
        als geeignete Garantien für den Schutz der personenbezogenen Daten,
        einsehbar unter: https://policies.google.com/privacy/frameworks
        (https://policies.google.com/privacy/frameworks).
        <br />
        Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage des
        Art. 6 Abs. 1 lit. f DSGVO aus unserem überwiegenden berechtigten
        Interesse unsere Website vor automatisierter Ausspähung, Missbrauch und
        SPAM zu schützen. Sie haben das Recht aus Gründen, die sich aus Ihrer
        besonderen Situation ergeben, jederzeit dieser auf Art. 6 Abs. 1 lit. f
        DSGVO beruhenden Verarbeitungen Sie betreffender personenbezogener Daten
        zu widersprechen.
        <br />
        Nähere Informationen zu Google reCAPTCHA sowie die dazugehörige
        Datenschutzerklärung finden Sie unter:
        https://www.google.com/recaptcha/intro/android.html
        (https://www.google.com/recaptcha/intro/android.html) sowie
        https://www.google.com/privacy (https://www.google.com/privacy)
        <br />
        <br />
        Verwendung von FontAwesome <br />
        Wir verwenden auf unserer Website Font Awesome der Fonticons Inc. (307 S
        Main St., Suite 202, Bentonville, AR, 72712-9214 USA "Font Awesome").
        Die Datenverarbeitung dient dem Zweck der einheitlichen Darstellung von
        Schriftarten und Icons auf unserer Website. Um die Schriftarten zu
        laden, wird beim Seitenaufruf eine Verbindung zu Servern von FontAwesome
        hergestellt. <br />
        Hierbei können Cookies eingesetzt werden. Dabei wird u.a. Ihre
        IP-Adresse sowie Informationen zu dem von Ihnen genutzten Browser
        verarbeitet und an Font Awesome übermittelt. Ihre Daten werden
        gegebenenfalls in Drittstaaten, wie die USA übermittelt. Für die USA ist
        kein Angemessenheitsbeschluss der EU-Kommission vorhanden. <br />
        Die Nutzung von Cookies oder vergleichbarer Technologien erfolgt mit
        Ihrer Einwilligung auf Grundlage des § 25 Abs. 1 S. 1 TTDSG i.V.m. Art.
        6 Abs. 1 lit. a DSGVO. Die Verarbeitung Ihrer personenbezogenen Daten
        erfolgt mit Ihrer Einwilligung auf Grundlage des Art. 6 Abs. 1 lit. a
        DSGVO. Sie können die Einwilligung jederzeit widerrufen, ohne dass die
        Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
        Verarbeitung berührt wird. <br />
        Nähere Informationen zur Datenverarbeitung und zum Datenschutz finden
        Sie unter https://fontawesome.com/privacy
        (https://fontawesome.com/privacy) sowie unter
        https://fontawesome.com/support (https://fontawesome.com/support).
        <br />
        <br />
        Betroffenenrechte und Speicherdauer
        <br />
        <br />
        Dauer der Speicherung
        <br />
        Nach vollständiger Vertragsabwicklung werden die Daten zunächst für die
        Dauer der Gewährleistungsfrist, danach unter Berücksichtigung
        gesetzlicher, insbesondere steuer- und handelsrechtlicher
        Aufbewahrungsfristen gespeichert und dann nach Fristablauf gelöscht,
        sofern Sie der weitergehenden Verarbeitung und Nutzung nicht zugestimmt
        haben.
        <br />
        <br />
        Rechte der betroffenen Person
        <br />
        Ihnen stehen bei Vorliegen der gesetzlichen Voraussetzungen folgende
        Rechte nach Art. 15 bis 20 DSGVO zu: Recht auf Auskunft, auf
        Berichtigung, auf Löschung, auf Einschränkung der Verarbeitung, auf
        Datenübertragbarkeit.
        <br />
        Außerdem steht Ihnen nach Art. 21 Abs. 1 DSGVO ein Widerspruchsrecht
        gegen die Verarbeitungen zu, die auf Art. 6 Abs. 1 f DSGVO beruhen,
        sowie gegen die Verarbeitung zum Zwecke von Direktwerbung.
        <br />
        <br />
        Beschwerderecht bei der Aufsichtsbehörde
        <br />
        Sie haben gemäß Art. 77 DSGVO das Recht, sich bei der Aufsichtsbehörde
        zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
        personenbezogenen Daten nicht rechtmäßig erfolgt.
        <br />
        <br />
        Widerspruchsrecht
        <br />
        Beruhen die hier aufgeführten personenbezogenen Datenverarbeitungen auf
        Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f
        DSGVO, haben Sie das Recht aus Gründen, die sich aus Ihrer besonderen
        Situation ergeben, jederzeit diesen Verarbeitungen mit Wirkung für die
        Zukunft zu widersprechen.
        <br />
        Nach erfolgtem Widerspruch wird die Verarbeitung der betroffenen Daten
        beendet, es sei denn, wir können zwingende schutzwürdige Gründe für die
        Verarbeitung nachweisen, die Ihren Interessen, Rechten und Freiheiten
        überwiegen, oder wenn die Verarbeitung der Geltendmachung, Ausübung oder
        Verteidigung von Rechtsansprüchen dient.
        <br />
        <br />
        Erfolgt die personenbezogene Datenverarbeitung zu Zwecken der
        Direktwerbung, können Sie dieser Verarbeitung jederzeit durch Mitteilung
        an uns widersprechen. Nach erfolgtem Widerspruch beenden wir die
        Verarbeitung der betroffenen Daten zum Zwecke der Direktwerbung.
        <br />
        <br />
        letzte Aktualisierung: 10.01.2022
      </div>
    );
  }
  initState(base: BasePageState): DatenschutzState {
    let newState: DatenschutzState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Datenschutz';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Datenschutz</span>;
  }
  getType(): string {
    return 'DatenschutzPage';
  }
}
